import * as React from 'react';
import { SystemAnnouncementDialog } from '../pages/global/menubar/SystemAnnouncementDialog';
import { useNestedDialogFunction } from '../../../../react-commons/dialog-provider/UseNestedDialogFunction';
import { useUserId } from '../authentication/useUserId';
import {
    useSystemAnnouncementActions,
} from '../../resource/resources/persistables/system/announcement/systemAnnouncementResource';

export const useShowSystemAnnouncements = () => {
    const nestedDialogFunction = useNestedDialogFunction();
    const userId = useUserId('');

    const systemAnnouncementActions = useSystemAnnouncementActions();

    const systemAnnouncements = systemAnnouncementActions.useGetAllActiveSystemAnnouncements(userId);

    React.useEffect(() => {
        if (systemAnnouncements.data) {
            const announcement = systemAnnouncements.data.find(value => !value.dismissed);
            if (announcement) {
                nestedDialogFunction.showNestedDialog(
                    <SystemAnnouncementDialog id={announcement.id} needsDismiss={true}
                                              onClose={nestedDialogFunction.closeNestedDialog} />,
                );
            }
        }
    }, [systemAnnouncements.data]);
};
